import bodyFixPosition from "./bodyFixPosition";
import bodyUnfixPosition from "./bodyUnfixPosition";
import setRussianErrorMessage from "./setRussianErrorMessage";

function translateErrorsHandler(modal, signal) {

    const inputs = modal.querySelectorAll('input, textarea, select');
    inputs.forEach(input => {
        setRussianErrorMessage(input, signal);
    });
}

function initModal() {
    let abortController = null;
    MicroModal.init({
        onShow: (modal) => {
            abortController = new AbortController();
            const { signal } = abortController;
            bodyFixPosition();
            translateErrorsHandler(modal, signal);
        }, // [1]
        onClose: (modal) => {
            bodyUnfixPosition();
            if (abortController) {
                abortController.abort();
                abortController = null;
            }

        }, // [2]
        openTrigger: "data-custom-open", // [3]
        closeTrigger: "data-micromodal-close", // [4]
        disableScroll: true, // [5]
        disableFocus: true, // [6]
        awaitOpenAnimation: true, // [7]
        awaitCloseAnimation: true, // [8]
        debugMode: false,
    });
}

export default initModal;
